'use client'

import { useAuth } from '@/providers/auth-provider'
import { MainNav } from './main-nav'
import { UserNav } from './user-nav'
import { usePathname } from 'next/navigation'
import { HoldingsNav } from '../holdings/sub-nav-holdings'
import { MeetingsNav } from '../meetings/sub-nav-meetings'
import { SettingsNav } from '../settings/sub-nav-settings'
import { ImpersonationBanner } from '@/plugins/impersonate/components'
import { TracedLink } from './TracedLink'
import Image from 'next/image'

export function HeaderWithNav() {
  const auth = useAuth()
  const pathname = usePathname()

  // Log the auth object to debug
  //  console.log('Auth object:', auth)

  // Don't render the top menu if the user is not logged in
  // Check if auth.user exists, is not null, and is a valid user object with expected properties
  const isValidUser =
    auth.user && typeof auth.user === 'object' && (auth.user.id || auth.user.email)

  if (!isValidUser) {
    return (
      <header className="border-b print:hidden">
        <div className="flex h-16 items-center justify-between px-4">
          <TracedLink href="/" className="flex items-center">
            <Image
              src="/emda_logo.png"
              alt="Logo"
              width={87}
              height={40}
              style={{ width: 'auto', height: 'auto' }}
              priority
            />
          </TracedLink>
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <UserNav />
          </div>
        </div>
      </header>
    )
  }

  // Render the top menu if the user is logged in
  return (
    <header className="border-b print:hidden">
      <div className="flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-6">
          <TracedLink href="/" className="flex items-center">
            <Image
              src="/emda_logo.png"
              alt="Logo"
              width={120}
              height={40}
              style={{
                height: '2.5rem',
                width: 'auto',
              }}
              priority
            />
          </TracedLink>
          <MainNav />
        </div>
        <div className="flex items-center space-x-4 rtl:space-x-reverse">
          <UserNav />
        </div>
      </div>
      {pathname == '/' || pathname == '/meetings/all' ? (
        <div className="flex h-8 items-center justify-between px-4">
          <MeetingsNav />
        </div>
      ) : pathname.startsWith('/holdings') ? (
        <div className="flex h-8 items-center justify-between px-4">
          <HoldingsNav />
        </div>
      ) : pathname.startsWith('/settings') ? (
        <div className="flex h-8 items-center justify-between px-4">
          <SettingsNav />
        </div>
      ) : null}
      <ImpersonationBanner position="top" locale="he" />
    </header>
  )
}
